import { SVGProps } from 'react';

const SvgHub = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 4a1 1 0 0 1 1 1v4.585l3.242-3.242a1 1 0 1 1 1.414 1.414L14.414 11H19a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-4.586l-3.243 3.243a1 1 0 0 1-1.414-1.414L9.585 13H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M17.656 17.657a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 1 1 1.415-1.414l9.9 9.9a1 1 0 0 1 0 1.414ZM.5 3.5a3 3 0 0 1 3-3h1.75a1 1 0 0 1 0 2H3.5a1 1 0 0 0-1 1v1.75a1 1 0 0 1-2 0V3.5ZM23.5 20.5a3 3 0 0 1-3 3h-1.75a1 1 0 1 1 0-2h1.75a1 1 0 0 0 1-1v-1.75a1 1 0 1 1 2 0v1.75ZM20.5.5a3 3 0 0 1 3 3v1.75a1 1 0 1 1-2 0V3.5a1 1 0 0 0-1-1h-1.75a1 1 0 1 1 0-2h1.75ZM3.5 23.5a3 3 0 0 1-3-3v-1.75a1 1 0 1 1 2 0v1.75a1 1 0 0 0 1 1h1.75a1 1 0 1 1 0 2H3.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHub;
